export default "__VITE_ASSET__Dl79QsOC__"